import { Common, Header, color, device } from '@stockbit/ui';
import styled, { keyframes } from 'styled-components';
import { Radio } from 'antd';

const { Flex, PopoverContent, Button, Avatar } = Common;
const { PopoverContainer } = Header;
const { Group: RadioGroup } = Radio;

interface NotifListContentProps {
  maxLine?: any;
}

const NotifListContainer = styled(Flex).attrs((props) => ({
  isNew: props.isNew,
}))`
  padding: 10px 15px;
  border-top: 1px solid ${color.whisper};
  background: ${({ isNew }) => (isNew ? color.downgray : color.light)};
  :hover {
    background: ${color.downgray};
  }

  @media ${device.tablet} {
    :last-child {
      border-bottom: none;
    }
  }
`;

const NotifListContent = styled.div<NotifListContentProps>`
  padding-left: 12px;
  width: calc(100% - 20px);
  & > p {
    position: relative;
    text-overflow: ellipsis;
    word-wrap: break-word;
    overflow: hidden;
    line-height: 1.4em;
    word-break: break-word;
    width: 100%;
  }
`;
const CustomPopoverContainer = styled(PopoverContainer)`
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  border: none;
  overflow-y: auto;
  background: ${color.light};
`;

const PopoverContentMobile = styled(PopoverContent)`
  border-bottom: 1px solid ${color.gainsboro};
`;

const PopoverContentWeb = styled(PopoverContent)`
  max-height: 324px;
`;

const ButtonGroup = styled(RadioGroup).attrs({ optionType: 'button' })`
  display: flex;
  margin-bottom: 13px;
  margin-top: 15px;
  width: 80%;

  * {
    border-collapse: collapse;
  }

  .ant-radio:hover .ant-radio-inner {
    border-color: ${color.gainsboro};
  }

  .ant-radio-checked::after {
    content: unset;
  }

  .ant-radio-input:focus + .ant-radio-inner {
    box-shadow: unset;
  }

  .ant-radio-button-wrapper {
    align-items: center;
    border-width: 0.8px;
    border-color: ${color.lowgray};
    color: ${color.midgray};
    display: flex;
    font-family: 'ProximaNovaRg', sans-serif;
    font-size: 12px;
    height: 28px;
    justify-content: center;
    width: calc(100% / 3);
    padding: 0px 10px;

    &:first-child {
      border-top-left-radius: 2px;
      border-bottom-left-radius: 2px;
    }

    &:last-child {
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
    }
  }

  .ant-radio-button-wrapper + .ant-radio-button-wrapper {
    margin-left: -1px;
  }

  .ant-radio-button-wrapper:hover {
    color: unset;
    background: unset;
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: ${color.primary};
    background: ${color.light};
    border-color: ${color.primary} !important;
    box-shadow: unset;
  }

  .ant-radio-button-wrapper:not(:first-child)::before {
    content: unset;
  }

  span {
    font-size: 14px;
  }
`;

const CloseButton = styled(Button)`
  border: none;
  padding: 0px;
  color: ${color.suvaGrey};
`;

const NotificationCount = styled.span`
  display: block;
  position: absolute;
  top: 7%;
  left: 7%;
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  padding: 0 2px;
  background-color: ${color.primary};
  border-radius: 10px;
  font-size: 11px;
  color: ${color.light};
  text-align: center;
  // TODO: Add color to @stockbit/ui
  border: 1px solid #8f8f8f;
`;

const IconContainer = styled(Avatar)`
  img {
    background-color: transparent;
    width: 18px;
    height: 18px;
    border: none;
    border-radius: 0%;
  }
`;

const LineAnimation = keyframes`
  from {
    left: -200px;
    width: 30%;
  }
  50% {
    width: 30%;
  }
  70% {
    width: 70%;
  }
  80% {
    left: 50%;
  }
  95% {
    left: 120%;
  }
  to {
    left: 100%;
  }
`;

interface LineLoaderProps {
  isLoading: boolean;
}

const LineLoader = styled.div<LineLoaderProps>`
  height: 1px;
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: #dadada;
  display: ${({ isLoading }) => (isLoading ? 'block' : 'none')};

  :before {
    display: block;
    position: absolute;
    content: '';
    left: -200px;
    width: 200px;
    height: 1px;
    background-color: #00ab6b;
    animation: ${LineAnimation} 2s linear infinite;
  }
`;

const DayTradeWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  background: #f2f1fe;
  border-radius: 100%;

  svg {
    height: 16px;
    width: 16px;
    color: #8277f8;
  }
`;

export {
  NotifListContainer,
  NotifListContent,
  CustomPopoverContainer,
  PopoverContentMobile,
  PopoverContentWeb,
  ButtonGroup,
  CloseButton,
  NotificationCount,
  IconContainer,
  LineLoader,
  DayTradeWrapper,
};
